const CR_ACCOUNT_NUMBER = "001"

export {CR_ACCOUNT_NUMBER}
